import gql from "graphql-tag"

const DELETE_SHIPPING_FEE_MODIFICATION = gql`
  mutation deleteOrderModificationShippingFees($modificationId: ID!) {
    Order {
      deleteOrderModificationShippingFees(modificationId: $modificationId) {
        status
      }
    }
  }
`

export default DELETE_SHIPPING_FEE_MODIFICATION
